import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { FoodChallengeBlockData } from '../../models/foodChallengeBlockData';

type Props = {
  enabled?: boolean;
  userBlockId: string;
};

export const useFetchFoodChallenges = ({
  enabled = true,
  userBlockId,
}: Props) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchActiveFoodChallenges = async (): Promise<
    FoodChallengeBlockData[]
  > => {
    return await api({
      route: `/private/dashboard/user/blocks/${userBlockId}/food_challenges`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<
    FoodChallengeBlockData[],
    Error
  >({
    queryKey: ['food-challenges', userToken, userBlockId],
    queryFn: fetchActiveFoodChallenges,
    enabled:
      enabled && isAuthenticated && !loading && !!userToken && !!userBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    activeFoodChallenges: data ?? [],
    isLoading,
    isError,
  };
};
